import { useTheme } from '@/hooks/useTheme';

const SIZES = {
  xs: {
    width: 24,
    height: 19,
  },
  lg: {
    width: 48,
    height: 38,
  },
};

export function Logo({
  className,
  size = 'xs',
}: {
  className?: string;
  size?: keyof typeof SIZES;
}) {
  const { theme } = useTheme();
  const sizeObj = SIZES[size];
  const color = 'currentColor';

  if (theme === 'dark') {
    return (
      <svg
        className={className}
        {...sizeObj}
        viewBox="0 0 24 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M21.1611 0C22.4518 7.70717e-05 23.4978 1.04629 23.498 2.33691V15.7764C23.498 17.0672 22.4519 18.1142 21.1611 18.1143H2.33691C1.04624 18.1141 0 17.0671 0 15.7764V2.33691C0.00020017 1.04636 1.04636 0.000197846 2.33691 0H21.1611ZM3.95801 10.1055C3.95816 12.622 7.44628 14.6621 11.749 14.6621C16.0518 14.6621 19.5399 12.622 19.54 10.1055H3.95801ZM6.81445 4.20215C5.24895 4.20242 3.9796 5.47157 3.97949 7.03711H5.55957C5.55968 6.34418 6.12156 5.78249 6.81445 5.78223C7.50757 5.78223 8.06923 6.34402 8.06934 7.03711H9.64941C9.64931 5.47141 8.38018 4.20215 6.81445 4.20215ZM16.584 4.20215C15.0183 4.20226 13.7491 5.47147 13.749 7.03711H15.3291C15.3292 6.34408 15.891 5.78233 16.584 5.78223C17.2769 5.78243 17.8388 6.34414 17.8389 7.03711H19.4189C19.4188 5.47153 18.1495 4.20235 16.584 4.20215Z"
          fill="currentColor"
        />
      </svg>
    );
  }

  return (
    <svg
      className={className}
      viewBox="0 0 24 19"
      fill="none"
      {...sizeObj}
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.75"
        y="0.75"
        width="21.9983"
        height="16.6139"
        rx="1.58728"
        stroke={color}
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        d="M11.7492 14.2421C9.65904 14.2421 7.78723 13.7454 6.45232 12.9647C5.28785 12.2837 4.58581 11.4235 4.41814 10.5253H19.0802C18.9126 11.4235 18.2105 12.2837 17.0461 12.9647C15.7112 13.7455 13.8394 14.2421 11.7492 14.2421Z"
        fill={color}
        stroke={color}
        strokeWidth="0.840407"
      />
      <path
        d="M18.6289 7.03687C18.6289 5.90738 17.7133 4.99175 16.5838 4.99175C15.4543 4.99175 14.5387 5.90738 14.5387 7.03687"
        stroke={color}
        strokeWidth="1.58"
      />
      <path
        d="M8.86007 7.03687C8.86007 5.90738 7.94444 4.99175 6.81495 4.99175C5.68546 4.99175 4.76983 5.90738 4.76983 7.03687"
        stroke={color}
        strokeWidth="1.58"
      />
    </svg>
  );
}
